import { useTranslations } from "contexts/LocalizationContext/hooks";
import { useModal } from "contexts/ModalContext";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import { SectionHeader } from "modules/common/components/SectionHeader";
import { ReviewCard } from "modules/common/components/Trustpilot";
import { Grid } from "modules/common/components/Grid";
import { Button, Stack, Image, Flex } from "@chakra-ui/react";
import { Modal } from "../../Modal";
import type { PreheaderSectionProps } from "../Sections.d";

import { SHARE_NOW_CUSTOMERS_SAY_EVENT_UA, SHARE_NOW_CUSTOMERS_SAY_EVENT } from "../../utils/trackingConsts";

export const CustomersSay = ({ preheader, title, content, buttonText, imgSrc }: PreheaderSectionProps) => {
  const translations = useTranslations();
  const { openModal } = useModal();

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackUAEvent(SHARE_NOW_CUSTOMERS_SAY_EVENT_UA);
    trackCustomEvent(SHARE_NOW_CUSTOMERS_SAY_EVENT);
  };

  const review = {
    id: "review-card",
    consumer: {
      displayName: translations("what_customers_say_review_author"),
      displayLocation: translations("what_customers_say_review_location"),
    },
    text: translations("what_customers_say_review"),
  };

  return (
    <Grid mb={{ base: 16, lg: 28 }} justify-content="center">
      <Stack
        gridColumn={{ base: "initial", md: "1 / span 6", lg: "1 / span 5" }}
        backgroundColor={{ base: "white", lg: "initial" }}
        spacing={8}
        py={{ base: 0, md: 8 }}
      >
        <SectionHeader
          dataTestId="customers-header"
          header={title}
          preheader={preheader}
          alignItems="flex-start"
          spacing={2}
        />
        {!isEmpty(content) && <RichtextAdapter content={content} customStyles={contentStyles} />}
        <Button
          data-testid="customers-share-now"
          px={10}
          width={{ base: "100%", md: "fit-content" }}
          onClick={clickHandler}
          title={buttonText || translations("button_share_now")}
        >
          {buttonText || translations("button_share_now")}
        </Button>
      </Stack>
      <Flex gridColumn={{ base: "initial", md: "8 / span 6" }} pos="relative" align="center">
        <Image
          display={{ base: "none", lg: "block" }}
          borderRadius="xl"
          src={imgSrc}
          pos="absolute"
          h="full"
          alt={translations("what_customers_say_review_image_alt")}
          objectFit="cover"
          loading="lazy"
        />
        <ReviewCard
          pos={{ lg: "absolute" }}
          left="-4rem"
          top="50%"
          transform={{ lg: "translateY(-50%)" }}
          review={review}
          width={{ md: "311px" }}
          data-testid="customers-img-review"
          border="none"
          boxShadow="alt"
          height="340px"
          isHero
        />
      </Flex>
    </Grid>
  );
};
